// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const latias_mega: PokeData = {
  "id": 10062,
  "name": "latias-mega",
  "height": 18,
  "weight": 520,
  "base_experience": 315,
  "types": [
    PokeType.DRAGON,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psychic",
    "recover",
    "psywave",
    "charm",
    "safeguard",
    "dragon-breath",
    "helping-hand",
    "wish",
    "refresh",
    "mist-ball",
    "water-sport",
    "healing-wish",
    "psycho-shift",
    "dragon-pulse",
    "zen-headbutt",
    "guard-split",
    "stored-power",
    "heal-pulse",
    "reflect-type"
  ],
  "moves": [
    "psychic",
    "psywave",
    "dragon-breath",
    "refresh",
    "healing-wish",
    "dragon-pulse",
    "zen-headbutt",
    "psy-ball",
    "psychic-fangs",
    "psychic-terrain",
    "kinesis",
    "dragon-vortex",
    "future-sight"
  ],
  "evolution_chain": {
    "id": 196,
    "item": null,
    "species": [
      {
        "name": "latias",
        "order": 410,
        "types": [
          PokeType.DRAGON,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 123,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
